import UserDetail from './userDetailReducer';
import UserProfile from '../components/userProfile/reducer';
import ProtocolBuilder from '../components/protocolBuilder/reducer';
import SurveyBuilder from '../components/surveyBuilder/reducer';
import ExternalModules from '../components/externalModules/reducer';

export default {
  UserDetail,
  UserProfile,
  ProtocolBuilder,
  SurveyBuilder,
  ExternalModules,
};
